<template>
<div>

    <section class="section-white" id="section-banner">
        <div class="container">
            <div class="row">
                <div class="col-sm-4 col-xs-12">
                    <img :src="`${publicPath}img/banner-left-min.png`" alt="" class="img-responsive">
                    <div class="m-t-50 m-b-50 text-center">
                        <a href="" @click.prevent="$router.push('/comercios')" class="btn btn-lg bgm-orange">VER MAPA DE COMERCIOS</a>
                    </div>
                </div>
                <div class="col-sm-8 col-xs-12 hidden-xs">
                    <img :src="`${publicPath}img/banner-right-min.png`" alt="" class="img-responsive">
                </div>
            </div>
        </div>
    </section>

    <!-- callToAction -->
    <!--
    <section class="call-to-action" id="section-call-to-action">
        <div class="container">
            <div class="row vertical-align">
                <div class="col-sm-9 col-xs-12">
                    <h2>ENCONTRÁ TU COMERCIO CERCANO</h2>
                    <p>A través del <strong>Mapa de Comercios</strong> georreferenciado, construido colaborativamente entre estudiantes, docentes, personal nodocente y graduados/as de la UNC, cualquier persona podrá acceder a información de localización, productos, medios de pago, tipos de entregas y canales de comunicación de los distintos comercios de Córdoba.</p> 
                </div>
                <div class="col-sm-3 col-xs-12">
                    <div>
                        <a href="" @click.prevent="$router.push('/comercios')" class="btn btn-default btn-lg"><i class="zmdi zmdi-arrow-right zmdi-hc-lg m-r-5"></i> Ver mapa de comercios</a>
                    </div>
                </div>
            </div>
        </div>
    -->
    </section>

    <!-- Intro -->
    <section class="section-bluelight" id="section-home">
        <div class="container">
        <div class="row">
                <div class="col-xs-12">
                    <h1>¿QUÉ ES TENDIENDO PUENTES?</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <p>Tendiendo Puentes es un proyecto que pretende al mismo tiempo dar visibilidad y presencia en canales electrónicos a pequeños y medianos comerciantes locales y ofrecer a los ciudadanos y ciudadanas información sobre los comercios locales para facilitar sus decisiones de consumo. El proyecto nace al calor de las circunstancias generadas por la pandemia de COVID19 que aceleraron la importancia de los canales electrónicos para el comercio.</p> 
                </div>
                <div class="col-sm-6 col-xs-12">
                    <p>De esta manera, se pretende tender puentes entre pequeños y medianos comercios y consumidores, publicando, de manera gratuita, un Mapa digital georreferenciado e interactivo de comercios, que contenga la información relevante de cada comercio para facilitar su vinculación con consumidores.</p>
                    <p>Tendiendo Puentes es una iniciativa del Programa de Compromiso Social Estudiantil de la Universidad Nacional de Córdoba. Sus unidades ejecutoras son la Secretaría de Extensión Universitaria del Área Central de la Universidad y la Facultad de Ciencias Económicas.</p>
                </div>
            </div>
        </div>
    </section>

    <!-- Perfiles de participación -->
    <section class="section-white" id="section-roles">
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <h1>¡QUIERO PARTICIPAR!</h1>
                    <!--<h2 class="subTitle">¡Formá parte! Si sos estudiante, graduado/a, docente y/o no docente de la UNC, podrás participar en los roles de relevador/a digital y telefónico, o tutores/as pares. </h2>-->
                </div>
            </div>

            <div class="row box-participante vertical-align">
                <div class="col-sm-5 col-xs-12">
                    <img :src="`${publicPath}img/soy-comerciante-min.png`" alt="" class="img-responsive">
                </div>
                <div class="col-sm-7 col-xs-12">
                    <h2>Soy comerciante</h2>
                    <p>Este proyecto fue creado para vos. Si tenés un comercio, emprendimiento o pyme y querés potenciar tus canales de vinculación con tus clientes, podés contactarnos para formar parte de Tendiendo Puentes y que tu comercio aparezca en el Mapa Digital. La participación en el proyecto es totalmente gratuita.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSdy9TyFclYEWD1ps0DoK1oZ56mChkhnhDx2roqVe_JlLSfQbA/viewform" target="_blank" class="btn btn-primary btn-lg m-t-20 m-b-20">Participar</a>
                </div>
            </div>

            <hr>
            
            <div class="row box-participante vertical-align">
                <div class="col-xs-12 visible-xs">
                    <img :src="`${publicPath}img/soy-voluntario-min.png`" alt="" class="img-responsive">
                </div>
                <div class="col-sm-7 col-xs-12">
                    <h2>Soy estudiante</h2>
                    <p>Tu participación es fundamental, dado que sos la persona de contacto de la UNC con los comercios. Tendrás la responsabilidad de invitar a cada comerciante a formar parte del <strong>Mapa de Comercios Tendiendo Puentes UNC</strong>. Con el tiempo que dediques al proyecto ayudarás a darles visibilidad digital a los pequeños comercios para que puedan potenciar sus ventas, y contribuirás con que más personas tomen mejores decisiones de compra. </p>
                    <p><em>*La participación de estudiantes acreditará 30 horas de acciones en el marco del programa CSE.</em></p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZ_zLUJy9UDTM66WJNz7SiKOX0n_IB4nmZPKWwjZMA-R-Vyw/viewform" target="_blank" class="btn btn-primary btn-lg m-t-20 m-b-20">Participar</a>
                </div>
                <div class="col-sm-5 hidden-xs">
                    <img :src="`${publicPath}img/soy-voluntario-min.png`" alt="" class="img-responsive">
                </div>
            </div>

            <hr>

            <div class="row box-participante vertical-align">
                <div class="col-sm-5 col-xs-12">
                    <img :src="`${publicPath}img/soy-tutor-min.png`" alt="" class="img-responsive">
                </div>
                <div class="col-sm-7 col-xs-12">
                    <h2>Soy docente, graduado/a o trabajador/a de la UNC</h2>
                    <p>Podes aportar al proyecto orientando y supervisando la tarea de un grupo de estudiantes. El Rol de  tutor/a es fundamental en este proyecto. Tiene la responsabilidad de orientar a  su grupo de estudiantes, es quien monitorea y corrobora la información que se genera y velar por la seguridad, confianza y transparencia de la información que publicará la UNC en su Mapa de Comercios.</p>
                    <a href="https://docs.google.com/forms/d/e/1FAIpQLScNC9EIchw1-8AFRbS-U0s3Rs0wwNojJiJUUTM_8xbr9hAQKw/viewform" target="_blank" class="btn btn-primary btn-lg m-t-20 m-b-20">Participar</a>
                </div>
            </div>

        </div>
    </section>

    <!-- FAQ -->
    <section class="section-orange" id="section-faq">
        <div class="container">
            <div class="row">
                <div class="col-xs-12">
                    <h1>PREGUNTAS FRECUENTES</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-xs-12">
                    <div class="panel-group" data-collapse-color="amber" role="tablist" aria-multiselectable="true">
                        <div class="panel panel-collapse">
                            <div class="panel-heading" role="tab" id="heading01">
                                <h4 class="panel-title">
                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse01" aria-expanded="false" aria-controls="collapse01">
                                        ¿Tengo que pagar algo para que pueda verse mi comercio? 
                                    </a>
                                </h4>
                            </div>
                            <div id="collapse01" class="collapse" role="tabpanel" aria-labelledby="heading01">
                                <div class="panel-body">
                                    No, esta es una Web gratuita que permite visualizar su comercio en un Mapa georreferenciado realizado por la Universidad.
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-collapse">
                            <div class="panel-heading" role="tab" id="heading02">
                                <h4 class="panel-title">
                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse02" aria-expanded="false" aria-controls="collapse02">
                                        ¿Qué información tengo que dar de mi comercio? 
                                    </a>
                                </h4>
                            </div>
                            <div id="collapse02" class="collapse" role="tabpanel" aria-labelledby="heading02">
                                <div class="panel-body">
                                    Sólo vamos a pedir datos de contacto del comercio, de los productos y servicios que ofrece, de los medios de pago y de las zonas y condiciones de entrega. No solicitaremos información fiscal ni documentación formal del comercio. Además, el proyecto sólo compartirá la información que sea autorizada por sus propietarios a publicar.
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-collapse">
                            <div class="panel-heading" role="tab" id="heading03">
                                <h4 class="panel-title">
                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse03" aria-expanded="false" aria-controls="collapse03">
                                        ¿Cuándo y cómo voy a poder ver mi comercio en el mapa? 
                                    </a>
                                </h4>
                            </div>
                            <div id="collapse03" class="collapse" role="tabpanel" aria-labelledby="heading03">
                                <div class="panel-body">
                                    Nosotros nos estaremos comunicando con usted por mail para informarle que la carga de datos ha sido exitosa, y que ya puede ver su comercio en el Mapa a través del link que le proporcionaremos.
                                </div>
                            </div>
                        </div>

                        <div class="panel panel-collapse">
                            <div class="panel-heading" role="tab" id="heading04">
                                <h4 class="panel-title">
                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse04" aria-expanded="false" aria-controls="collapse04">
                                        ¿Y si cambio un dato o precios? 
                                    </a>
                                </h4>
                            </div>
                            <div id="collapse04" class="collapse" role="tabpanel" aria-labelledby="heading04">
                                <div class="panel-body">
                                    Cuando desee realizar un cambio, usted nos podrá informar por correo escribiendo a  tendiendopuentes@eco.uncor.edu
                                </div>
                            </div>
                        </div>

                        <div class="panel panel-collapse">
                            <div class="panel-heading" role="tab" id="heading05">
                                <h4 class="panel-title">
                                    <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse05" aria-expanded="false" aria-controls="collapse05">
                                        ¿Hasta cuándo va a quedar cargado y visibilizado?
                                    </a>
                                </h4>
                            </div>
                            <div id="collapse05" class="collapse" role="tabpanel" aria-labelledby="heading05">
                                <div class="panel-body">
                                    Mientras tenga vigencia el Mapa de Comercios, es una web de carga permanente. Si usted desea que su comercio sea dado de baja deberá solicitarlo escribiendo a <strong>tendiendopuentes@eco.uncor.edu</strong>.
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            
        </div>
    </section>
    <!-- participar -->

    <section id="section-footer">
        <div class="container">
            <div class="row">
                <div class="col-sm-3 col-xs-12">
                    <div class="footerWidget text-center">
                        <h3>Tendiendo Puentes</h3>
                        <address>
                        <p>Universidad Nacional de Córdoba<br>
                        tendiendopuentes@eco.uncor.edu<br>
                        Bv. Enrique Barros s/n - Ciudad Universitaria<br>
                        X5000HRV Córdoba - Argentina<br>
                        </p>
                        </address>
                    </div>
                </div>
                <div class="col-sm-9 col-xs-12 hidden-xs">
                    <img class="m-t-10 img-responsive" :src="`${publicPath}img/logo-footer-60-white-min.png`">
                </div>
            </div>

        </div>
    </section>
<!--       
    <section  id="footerRights">
        <div class="container">
            <div class="row">
                <div class="col-sm-6">
                    <p>Copyright © 2020.</p>
                </div>
                <div class="col-sm-6">
                    
                </div>
            </div>
        </div>
    </section> -->

</div>
</template>

<script>
    import particlesJS from './particlesJS'

    import { HTTPAPI, showResponseErrorMessage } from '../../share.js';
    import {Jumper} from 'vue-loading-spinner';

    export default {
        data() {
            return {
                publicPath: process.env.BASE_URL,
                homeLogos: [true,false,false,false,false]
            }
        },
        components: {
            Jumper,
            particlesJS
        },
        mounted() {
            setInterval(this.updateTicker, 3000);
        },
        methods: {
            updateTicker(){
                var removed = this.homeLogos.pop();
                this.homeLogos.unshift(removed);
            }
        }
    }
</script>

<style lang="scss" scoped>



    #section-banner {
        margin-top: 20px;

        padding-bottom: 0px;

        h2 {
            padding-bottom: 20px;
        }

        p {
            font-size: 20px;
        }
    }

    #section-home {
        h1 {
            color: #ffffff;
        }

        h2 {
            padding-bottom: 20px;
            color: #ffffff;
        }

        p {
            font-size: 20px;
        }
    }

    #section-call-to-action {
        padding: 30px 50px;
        background-color: #1292b0;
        color: #ffffff;

        h2 {
            font-size: 28px;
            line-height: 38px;
            font-weight: 400;
            font-style: normal;
            padding: 0;
            text-align: left;
            color: #ffffff;
        }

        p {
            font-size: 20px;
        }
    }

    #section-faq {

        padding-bottom: 30px;

        h1 {
            color: #ffffff;
            padding-bottom: 30px;
        }

        .panel-title {
            background-color: #e67c16;
        }

        .panel-title > a {
            font-size: 20px !important;
            color: #ffffff;
        }

        .panel-body {
            font-size: 20px;
            padding-bottom: 40px !important;
            color: #ffffff;
            background-color: #e67c16;
        }
    }

    .box-participante {

        padding: 10px 50px 30px 50px

        h2 {
            font-size: 35px;
            line-height: 38px;
            font-weight: 400;
            font-style: normal;
            padding: 0;
            margin-top: 35px;
            margin-bottom: 20px;
            text-align: left;
            color: #888;
        }

        p {
            font-size: 20px;
        }
    }

    @media (min-width: 768px) {
        .vertical-align {
            display: flex;
            align-items: center;
        }

        .box-participante {
            padding: 10px 50px 30px 50px;
        }
    }
    

    .homeLogos {
        min-height: 140px;
        img {
            max-height: 140px;
        }
    }

.m-t-50{
    margin-top: 50px;;
}   

.m-b-50{
    margin-bottom: 50px;
}

.m-b-40{
    margin-bottom: 40px;
}


section {
    padding: 50px 0;

    .section-white {
        background-color: #ffffff;
    }

    .section-gray {
        background-color: #f0f0f0
    }

    .section-red {
        background-color: #c42729;
        color: #ffffff;
    }

    .section-bluelight {
        background-color: #1292b0;
        color: #ffffff;
    }

    .section-orange {
        background-color: #e67c16;
        color: #ffffff;
    }

    .section-gray {
        background-color: #f0f0f0;
    }

    h1 {
        font-size: 44px;
        line-height: 44px;
        font-weight: 300;
        font-style: normal;
        text-align: center;
        text-transform: uppercase;
        position: relative;
        letter-spacing: 0.1em;
        margin-bottom: 50px;
    }

    h2.subTitle {
        font-size: 24px;
        line-height: 30px;
        font-weight: 300;
        font-style: normal;
        padding: 0;
        text-align: center;
        color: #888;
    }
}


/* FOOTER 
================================================== */

#footerLogo {margin-bottom: 22px;}
#footerRights {padding:22px; font-size:12px;}

@media(min-width:768px){.footerWidget{float:right;}}

#section-footer {
    color:#999;
    background:#333;
    border-top:1px solid #555;

    h3 {
        color: #999;
    }
}

#footerRights {
background-color:#fff;
color:#999;
}
p.credits {
color:#555;
}
p.credits a {
color:#4FAFC2;
}





.fade-enter-active, .fade-leave-active {
transition: opacity 1s
}
.fade-enter, .fade-leave-to {
opacity: 0
}


#home {
    font-family: 'Roboto', sans-serif;
    color: #fff;
    position: relative;
    margin: 0;
    padding-top: 0;
    padding-bottom: 0;

    h1 {
        font-weight: 300;
    }

    a {
        color: #fff;
    }

    .btn {
        border-radius: 45px;
        margin-bottom: 1px;
        font-family: 'Montserrat', sans-serif;
        text-transform: uppercase;
        font-weight: 300;
        letter-spacing: 2px;
        font-size: 10px;
        -webkit-transition: all 0.5s ease 0s;
        -moz-transition: all 0.5s ease 0s;
        -o-transition: all 0.5s ease 0s;
        transition: all 0.5s ease 0s;
    }

    .btn-default {
        color: rgb(164,52,58);
        // background-color: transparent;
        background-color: #fff;
        opacity: 0.8;
        border-color: #535353;
    }

    .btn-default:hover {
        color: #fff;
        background-color: #8980fe;
        border-color: #8980fe;
    }

    .btn-default.active.focus, .btn-default.active:focus, .btn-default.active:hover, .btn-default:active.focus, .btn-default:active:focus, .btn-default:active:hover, .open>.dropdown-toggle.btn-default.focus, .open>.dropdown-toggle.btn-default:focus, .open>.dropdown-toggle.btn-default:hover {
        color: #fff;
        background-color: #8980fe;
        border-color: #8980fe;
    }

    .btn.active.focus, .btn.active:focus, .btn.focus, .btn:active.focus, .btn:active:focus, .btn:focus {
        outline: none;
    }

    .btn-default.active, .btn-default:active, .open>.dropdown-toggle.btn-default {
        color: #fff;
        background-color: #8980fe;
        border-color: #8980fe;
    }

    .btn-default.disabled.focus, .btn-default.disabled:focus, .btn-default.disabled:hover, .btn-default[disabled].focus, .btn-default[disabled]:focus, .btn-default[disabled]:hover, fieldset[disabled] .btn-default.focus, fieldset[disabled] .btn-default:focus, fieldset[disabled] .btn-default:hover {
        color: #fff;
        background-color: #8980fe;
        border-color: #8980fe;
    }

    .btn-default.disabled.focus, .btn-default.disabled:focus, .btn-default.disabled:hover, .btn-default[disabled].focus, .btn-default[disabled]:focus, .btn-default[disabled]:hover, fieldset[disabled] .btn-default.focus, fieldset[disabled] .btn-default:focus, fieldset[disabled] .btn-default:hover {
        color: #fff;
    }

    .btn-primary {
        color: #fff;
        background-color: #8980fe;
        border-color: #8980fe;
    }

    .btn-primary:hover {
        color: #fff;
        background-color: #615fde;
        border-color: #615fde;
    }

    .btn-primary.active.focus, .btn-primary.active:focus, .btn-primary.active:hover, .btn-primary:active.focus, .btn-primary:active:focus, .btn-primary:active:hover, .open>.dropdown-toggle.btn-primary.focus, .open>.dropdown-toggle.btn-primary:focus, .open>.dropdown-toggle.btn-primary:hover {
        color: #fff;
        background-color: #615fde;
        border-color: #615fde;
    }

    .btn-primary.focus, .btn-primary:focus {
        color: #fff;
        background-color: #504ED2;
        border-color: #504ED2;
    }

    .btn.active.focus, .btn.active:focus, .btn.focus, .btn:active.focus, .btn:active:focus, .btn:focus {
        outline: none;
    }

    .btn-primary.active, .btn-primary:active, .open>.dropdown-toggle.btn-primary {
        color: #fff;
        background-color: #615fde;
        border-color: #615fde;
    }

    .btn-primary.disabled.focus, .btn-primary.disabled:focus, .btn-primary.disabled:hover, .btn-primary[disabled].focus, .btn-primary[disabled]:focus, .btn-primary[disabled]:hover, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary:hover {
        color: #fff;
        background-color: #615fde;
        border-color: #615fde;
    }

    .btn-primary.disabled.focus, .btn-primary.disabled:focus, .btn-primary.disabled:hover, .btn-primary[disabled].focus, .btn-primary[disabled]:focus, .btn-primary[disabled]:hover, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary:hover {
        color: #fff;
    }

    .btn-white {
        border-color: #fff;
    }

    .btn-lg {
        padding: 12px 26px;
    }


    hr {
        border-width: 1px 0px;
        border-style: dotted none;
        border-color: rgba(255, 255, 255, 0.35);
        -moz-border-top-colors: none;
        -moz-border-right-colors: none;
        -moz-border-bottom-colors: none;
        -moz-border-left-colors: none;
        border-image: none;
        width: 49px;
        height: 4px;
        text-align: center;
        position: relative;
        clear: both;
    }

    p {
        margin-bottom: 15px;
        font-size: 21px;
        font-weight: 300;
    }

.center-vertically-holder {
    display: table;
    height: 100%;
    padding-top: 160px;
}

.center-vertically {
    display: table-cell;
    vertical-align: middle;
    height: 100%;
}
}


</style>
